// extracted by mini-css-extract-plugin
export default {"basicRow":"y9jE_6zK","titleRow":"WIfkq_5r y9jE_6zK","expandedRow":"EPw1yE7V y9jE_6zK"};